import gql from 'graphql-tag';
import client from '../graphqlAPI';

const GET_USER_ROLES = gql`
query getUserRoles {
  getUserRoles {
    roles
  }
}
`;

const getUserRoles = async () => {
  try {
    const result = await client.query({
      query: GET_USER_ROLES,
      errorPolicy: 'all',
      fetchResults: true,
      fetchPolicy: 'no-cache',
    })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const { data: { getUserRoles: rolesData } } = result;

    if (rolesData) {
      return rolesData.roles || [];
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: getUserRoles = null`);
    return [];
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: getUserRoles Error: ${error}`);
    return [];
  }
};

export default getUserRoles;
